// @flow

export const POST_BODY_INIT = 'POST_BODY_INIT'
export const POST_BODY_EDIT = 'POST_BODY_EDIT'
export const POST_BODY_CANCEL = 'POST_BODY_CANCEL'
export const POST_BODY_UPDATE_FIELD = 'POST_BODY_UPDATE_FIELD'
export const POST_BODY_SAVE = 'POST_BODY_SAVE'
export const POST_BODY_SAVED = 'POST_BODY_SAVED'
